import config from '../../config'

const geoserverURL = `${config.geoserver.geoserverURL}/${config.geoserver.geoserverWorkspace}/wps`

/*
 **** postWPS
 **** Realiza una petición WPS (RasterZonalStatistics) a Geoserver
 **** @param {string} geojsonFeature -- Polígono para realizar la búsqueda JSONString
 **** @param {string} geoserver -- nombre del raster sobre el que se obtienen las estadísticas ej: workspace:layer
*/
export default function (layer, layerCrop) {
  const file = getRequestBody(layer, layerCrop)

  return fetch(geoserverURL, {
    method: 'POST',
    body: file,
    headers: new Headers({'content-type': 'application/xml'})
  })
  .then(res => res.json())
}


/*
 **** getSampleRequestBody
 **** Obtiene una plantilla del cuerpo de la petición WPS
 **** sin los valores del raster y polígono reemplazados
*/
function getRequestBody(layer, layerCrop) {
  const { 
    name, 
    nativeBoundingBox: { minx, maxx, miny, maxy, crs: { $: projection } }
  } = layer

  const epsgNumber = projection.replace('EPSG:', '')

  const workspace = config.geoserver.geoserverWorkspace

	return `<?xml version="1.0" encoding="UTF-8"?><wps:Execute version="1.0.0" service="WPS" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns="http://www.opengis.net/wps/1.0.0" xmlns:wfs="http://www.opengis.net/wfs" xmlns:wps="http://www.opengis.net/wps/1.0.0" xmlns:ows="http://www.opengis.net/ows/1.1" xmlns:gml="http://www.opengis.net/gml" xmlns:ogc="http://www.opengis.net/ogc" xmlns:wcs="http://www.opengis.net/wcs/1.1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xsi:schemaLocation="http://www.opengis.net/wps/1.0.0 http://schemas.opengis.net/wps/1.0.0/wpsAll.xsd">
      <ows:Identifier>ras:RasterZonalStatistics</ows:Identifier>
      <wps:DataInputs>
        <wps:Input>
          <ows:Identifier>data</ows:Identifier>
          <wps:Reference mimeType="image/tiff" xlink:href="http://geoserver/wcs" method="POST">
            <wps:Body>
              <wcs:GetCoverage service="WCS" version="1.1.1">
                <ows:Identifier>${name}</ows:Identifier>
                <wcs:DomainSubset>
                  <ows:BoundingBox crs="http://www.opengis.net/gml/srs/epsg.xml#${epsgNumber}">
                    <ows:LowerCorner>${minx} ${miny}</ows:LowerCorner>
                    <ows:UpperCorner>${maxx} ${maxy}</ows:UpperCorner>
                  </ows:BoundingBox>
                </wcs:DomainSubset>
                <wcs:Output format="image/tiff"/>
              </wcs:GetCoverage>
            </wps:Body>
          </wps:Reference>
        </wps:Input>
        <wps:Input>
          <ows:Identifier>band</ows:Identifier>
          <wps:Data>
            <wps:LiteralData>0</wps:LiteralData>
          </wps:Data>
        </wps:Input>
        <wps:Input>
        <ows:Identifier>zones</ows:Identifier>
        <wps:Reference mimeType="text/xml" xlink:href="http://geoserver/wfs" method="POST">
          <wps:Body>
            <wfs:GetFeature service="WFS" version="1.0.0" outputFormat="GML2" xmlns:${workspace}="/${workspace}">
              <wfs:Query typeName="${layerCrop}"/>
            </wfs:GetFeature>
          </wps:Body>
        </wps:Reference>
      </wps:Input>
      </wps:DataInputs>
      <wps:ResponseForm>
        <wps:RawDataOutput mimeType="application/json">
          <ows:Identifier>statistics</ows:Identifier>
        </wps:RawDataOutput>
      </wps:ResponseForm>
    </wps:Execute>`
}


// WEBPACK FOOTER //
// ./src/api/wps/RasterAverage.js